<template>
  <div class="classroom-header">
    <div class="d-flex align-center justify-space-between">
      <div>
        <Breadcrumbs headline="Quản lý phòng học" :link="[{ text: 'Quản lý phòng học', href: '/classrooms' }]" />
      </div>
      <v-btn color="primary" @click="$emit('create')" elevation="0" class="px-6">
        <v-icon left>mdi-plus</v-icon>
        Thêm phòng học mới
      </v-btn>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'

export default {
  name: 'ClassroomHeader',
  components: {
    Breadcrumbs,
  },
}
</script>

<style scoped>
.classroom-header {
  padding: 16px;
}
.headline {
  margin-bottom: 8px;
}
</style>
